import React from 'react';
import PropTypes from 'prop-types';
import { values as _values } from "lodash";
import moment from "moment";
import Translation from "../../../../commons/i18n/Translation";
import DayPicker from "../../../components/DayPicker";
import Constants from "../../../configurations/Constants";
import { CommonsConstants } from "../../../../commons/index";
import CustomSelect from "../../../../commons/components/CustomSelect";
import CustomSelectNullSafe from './CustomSelectNullSafe';


export default class SearchFilter extends React.Component {

    static propTypes = {
        query               : PropTypes.string,
        onChangeQuery       : PropTypes.func,
        contentType         : PropTypes.oneOf([Constants.CONTENT_FILTER.POST, Constants.CONTENT_FILTER.EVENT]),
        onChangeContentType : PropTypes.func,
        locality            : PropTypes.object,
        searchLocality      : PropTypes.func,
        onChangeLocality    : PropTypes.func,
        group               : PropTypes.object,
        searchGroup         : PropTypes.func,
        onChangeGroup       : PropTypes.func,
        eventDate           : PropTypes.string,
        onChangeEventDate   : PropTypes.func,
        surroundings        : PropTypes.oneOf(_values(Constants.SURROUNDING_FILTER)),
        onChangeSurroundings: PropTypes.func,
        onResetFilters      : PropTypes.func,
        language            : PropTypes.object,
        onChangeLanguage    : PropTypes.func
    };

    shouldComponentUpdate = (newProps) => {
        // Query
        if((newProps.query.length === 0) !== (this.props.query.length === 0)){
            return true
        }
        // Type
        if(newProps.contentType !== this.props.contentType){
            return true
        }

        if(newProps.surroundings !== this.props.surroundings){
            return true
        }
        // EventDate
        if(newProps.eventDate !== this.props.eventDate){
            return true
        }
        // City
        if(!this.objectExistsAndSameProperty(newProps.locality, this.props.locality, 'id') ||
            !this.objectExistsAndSameProperty(newProps.locality, this.props.locality, 'name')){
            // Locality Name is fetched lazy, do not update when id is set but not name
            return true;
        }
        // Organisation
        if(!this.objectExistsAndSameProperty(newProps.group, this.props.group, 'id') ||
            !this.objectExistsAndSameProperty(newProps.group, this.props.group, 'name')){
            // Group Name is fetched lazy, do not update when id is set but not name
            return true;
        }
        // Language
        if(!this.objectExistsAndSameProperty(newProps.language, this.props.language, 'id') ||
            !this.objectExistsAndSameProperty(newProps.language, this.props.language, 'name')){
            // language Name is fetched lazy, do not update when id is set but not name
            return true;
        }
        return false;
    };

    objectExistsAndSameProperty = (obj1, obj2, prop) => {
        if(!obj1 && !obj2){
            return true;
        }

        if(!obj1 || !obj2){
            return false;
        }

        if(obj1[prop] === obj2[prop]){
            return true;
        }
        return false
    };

    isEvent = () => this.props.contentType === Constants.CONTENT_FILTER.EVENT;

    onResetFilters = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onResetFilters();
    };

    renderLocality = () => (
        <div className="mywort-filters__section">
            { this.renderCitySelect() }
        </div>
    );

    renderContentType = () => (
        <div className="mywort-filters__section mywort-filters__section--first mywort-filters__section--small">
            <CustomSelect
                aria-label={this.props.types.map((el) => {return el.label}).join(", ")}
                options={this.props.types}
                value={this.props.selected}
                onChange={this.props.onChangeContentType}
                searchable={false}
                clearable={false}
                valueKey="value"
                labelKey="label"
            />
        </div>
    );

    renderEventDate = () => {
        let parsedDate = moment(this.props.eventDate, CommonsConstants.SIMPLE_DATE_API_FORMAT);
        let eventDate = parsedDate.isValid() ? parsedDate.format(CommonsConstants.SIMPLE_DATE_DISPLAY_FORMAT[Translation.getLanguageName()]) : "";

        return (
            <div className="mywort-filters__section mywort-filters__section--fixed">
                <label className="u-sr-only">{Translation.translate("search.filters.date.placeholder")}</label>
                <DayPicker
                    value={eventDate}
                    onDayChange={this.props.onChangeEventDate}
                    placeholder={Translation.translate("search.filters.date.placeholder")}
                    parseDate={date => {
                        let momentDate = moment(date, CommonsConstants.SIMPLE_DATE_DISPLAY_FORMAT[Translation.getLanguageName()], true);
                        return momentDate.isValid() ? momentDate.toDate() : undefined;
                    }}
                    locale={Translation.getLanguageName()}
                />
            </div>
        );
    }

    renderCitySelect = () => (
        <CustomSelectNullSafe
            aria-label={Translation.translate("commons.locality")}
            searchPromptText={Translation.translate("search.starttyping")}
            searchingText={Translation.translate("search.loading")}
            async debounceTime={500}
            placeholder={Translation.translate("commons.locality")}
            value={this.props.locality}
            onChange={this.props.onChangeLocality}
            loadOptions={(input, asyncSelectCallback) => this.props.searchLocality(input, asyncSelectCallback)}
            valueKey="id"
            labelKey="name"
            minimumInput={2}
        />
    );

    renderSurroundings = () => {
        let options = [
            { label: Translation.translate("search.filters.locality"), value:Constants.SURROUNDING_FILTER.LOCALITY},
            { label: Translation.translate("search.filters.municipality"), value:Constants.SURROUNDING_FILTER.MUNICIPALITY},
            { label: Translation.translate("search.filters.around"), value:Constants.SURROUNDING_FILTER.AROUND}
        ];
        return <div className="mywort-filters__section mywort-filters__section--small">
            <CustomSelect
                aria-label={Translation.translate("commons.locality")}
                options={options}
                value={this.props.surroundings}
                onChange={this.props.onChangeSurroundings}
                searchable={false}
                clearable={false}
                valueKey="value"
                labelKey="label"
            />
        </div>
    };

    renderGroupSelect = () => (
        <CustomSelectNullSafe
            async debounceTime={500}
            aria-label={Translation.translate("commons.group")}
            placeholder={Translation.translate("commons.group")}
            value={this.props.group}
            onChange={this.props.onChangeGroup}
            loadOptions={(input, asyncSelectCallback) => this.props.searchGroup(input, asyncSelectCallback)}
            valueKey="id"
            labelKey="name"
            minimumInput={2}
        />
    );

    renderGroup = () => (
        <div className="mywort-filters__section">
            {this.renderGroupSelect()}
        </div>
    );

    renderLanguage = () => (
        <div className="mywort-filters__section mywort-filters__section--first mywort-filters__section--small">
            <CustomSelect
                aria-label={Translation.translate("commons.language")}
                placeholder={Translation.translate("commons.language")}
                value={this.props.language}
                onChange={this.props.onChangeLanguage}
                options={CommonsConstants.LANGUAGES}
                valueKey="id"
                labelKey="name"
                searchable={false}
                clearable={true}
            />
        </div>
    );

    renderClearFilter = () => {
        if(!this.props.query && !this.props.locality && !this.props.group && !this.props.eventDate){
            return null
        }
        return <div className="mywort-filters__section mywort-filters__section--last">
            <a href="" className="mywort-filters__reset-filters mywort-link mywort-link--gray"
               onClick={this.onResetFilters}>
                {Translation.translate("search.filters.reset")}
            </a>
        </div>
    };

    render = () => (
        <div className="mywort-filters mywort-filters--inline">
            { this.renderContentType() }
            { this.renderLocality() }
            { this.props.locality ? this.renderSurroundings() : null }
            { this.renderGroup() }
            { this.renderLanguage() }
            { this.isEvent() ? this.renderEventDate() : null }
            { this.renderClearFilter() }
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/desktop/SearchFilter.jsx